export default {
      id: "menu-usage",
      viewBox: "0 0 16 10",
      url: __webpack_public_path__ + "img/icons.79e00d12.svg#menu",
      toString: function () {
        return this.url;
      }
    }